import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Checkbox,
	CircularProgress,
	Grid,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ComboCryptoCoins from "../ComboCryptoCoins";
import ComboNetwork from "../ComboNetwork";
import InputCryptoAddress from "../InputCryptoAddress";
import one from "../../assets/images/one.png";
import two from "../../assets/images/two.png";
import three from "../../assets/images/three.png";
import { returnNetwork } from "../../utils/NetworkFunctions.js";
import InputDollarAmount from "../InputDollarAmount";
import toast, { Toaster } from "react-hot-toast";
import { agentRequestWithdrawal } from "../../actions/withdrawal";
import InputAmountMax from "../InputAmountMax.js";
import { getAgentDashboardBalances } from "../../actions/agent.js";
import { useNavigate } from "react-router";
import { Networks } from "../../enums/networks.js";
import { CryptoCurrencies } from "../../enums/CryptoCurrenciesCombo.js";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils.js";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	textTransform: "capitalize",
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const SelectCrypto = (props) => {
	const {
		setCryptoCurrency,
		cryptoCurrency,
		setNetwork,
		network,
		title,
		agreement,
		setAgreement,
		address,
		setAddress,
		step,
		setStep,
		token,
		amount,
		setAmount,
		id,
		setWithdrawal,
	} = props;

	const [balances, setBalances] = useState(null);
	const [balance, setBalance] = useState(0);
	const navigate = useNavigate();
	const [processing, setProcessing] = useState(false);
	const [currency, setCurrency] = useState("USD");
	const [exchangeRate, setExchangeRate] = useState(0);
	const [maxSet, setMaxSet] = useState(false);

	const [disable, setDisable] = useState(true);
	const nextStep = (e) => {
		e.preventDefault();
		setDisable(true);
		const exchange = getExchangeByCrypto(cryptoCurrency);
		let tempAmount = 0;
		if (currency === "USD") {
			if (maxSet) {
				tempAmount = balance;
			} else {
				tempAmount = parseFloat(parseFloat(amount / exchange).toFixed(getDecimalsByCrypto(cryptoCurrency)));
			}
		} else {
			tempAmount = parseFloat(parseFloat(amount).toFixed(getDecimalsByCrypto(cryptoCurrency)));
		}

		if (parseFloat(tempAmount) > parseFloat(balance)) {
			toast.error(`Amount is greater than balance`);
		} else if (tempAmount <= 0) {
			toast.error(`Amount must be greater than cero`);
		} else {
			console.log("address", address);
			if (address) {
				setProcessing(true);
				agentRequestWithdrawal(token, cryptoCurrency, network, address, tempAmount, currency, maxSet, (res) => {
					setProcessing(false);
					if (res.error === true) {
						toast.error(res.message);
					}else{
						setWithdrawal(res.data);
						setStep(2);
					}
				});
			} else {
				toast.error(`Insert a valid address`);
			}
		}
		setDisable(false);
	};

	const changeAgreement = (e) => {
		setAgreement(e.target.checked);
		setDisable(!e.target.checked);
	};

	const getExchangeByCrypto = () => {
		let exch = 0;
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				exch = balances?.exchangeRate?.exchangeRateBTC ?? 0;
				break;
			case CryptoCurrencies.ETHEREUM:
				exch = balances?.exchangeRate?.exchangeRateETH ?? 0;
				break;
			case CryptoCurrencies.USDT:
				exch = balances?.exchangeRate?.exchangeRateUSDT ?? 0;
				break;
			case CryptoCurrencies.USDC:
				exch = balances?.exchangeRate?.exchangeRateUSDC ?? 0;
				break;
			case CryptoCurrencies.TRX:
				exch = balances?.exchangeRate?.exchangeRateTRX ?? 0;
				break;
			case CryptoCurrencies.LITECOIN:
				exch = balances?.exchangeRate?.exchangeRateLTC ?? 0;
				break;
			case CryptoCurrencies.DOGECOIN:
				exch = balances?.exchangeRate?.exchangeRateDOGE ?? 0;
				break;
			case CryptoCurrencies.XRP:
				exch = balances?.exchangeRate?.exchangeRateXRP ?? 0;
				break;
			default:
				exch = 0;
				break;
		}
		setExchangeRate(exch);
		return exch;
	};

	useEffect(() => {
		getAgentDashboardBalances(token, id, (res) => {
			if (!res.error) {
				setBalances(res.data);
				getExchangeByCrypto();
				switch (network) {
					case Networks.BITCOIN:
						setBalance(parseFloat(parseFloat(res.data.balances.balanceBTC).toFixed(getDecimalsByCrypto(CryptoCurrencies.BITCOIN))));
						break;
					case Networks.ETHEREUM:
						if (cryptoCurrency === CryptoCurrencies.ETHEREUM) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceETH).toFixed(getDecimalsByCrypto(CryptoCurrencies.ETHEREUM))));
						} else if (cryptoCurrency === CryptoCurrencies.USDT) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceUSDT).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDT))));
						} else if (cryptoCurrency === CryptoCurrencies.USDC) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceUSDC).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDC))));
						}
						break;
					case Networks.TRON:
						if (cryptoCurrency === CryptoCurrencies.TRX) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceTRX).toFixed(getDecimalsByCrypto(CryptoCurrencies.TRX))));
						} else if (cryptoCurrency === CryptoCurrencies.USDT) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceUSDTTRON).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDT))));
						}
						break;
					case Networks.BASE:
						if (cryptoCurrency === CryptoCurrencies.ETHEREUM) {
							setBalance(
								parseFloat(parseFloat(res.data.balances.balanceETHBASE).toFixed(getDecimalsByCrypto(CryptoCurrencies.ETHEREUM)))
							);
						} else if (cryptoCurrency === CryptoCurrencies.USDC) {
							setBalance(parseFloat(parseFloat(res.data.balances.balanceUSDCBASE).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDC))));
						}
						break;
					case Networks.DOGECOIN:
						setBalance(parseFloat(parseFloat(res.data.balances.balanceDOGE).toFixed(getDecimalsByCrypto(CryptoCurrencies.DOGECOIN))));
						break;
					case Networks.LITECOIN:
						setBalance(parseFloat(parseFloat(res.data.balances.balanceLITECOIN).toFixed(getDecimalsByCrypto(CryptoCurrencies.LITECOIN))));
						break;
					case Networks.RIPPLE:
						setBalance(parseFloat(parseFloat(res.data.balances.balanceXRP).toFixed(getDecimalsByCrypto(CryptoCurrencies.RIPPLE))));
						break;
					default:
						setBalance(0);
						break;
				}
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, [network]);

	if (processing) {
		return (
			<>
				<Grid container spacing={2} sx={{ justifyContent: "center", textAlign: "center" }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<Card sx={{ maxWidth: 500, minWidth: 500 }}>
							<CardContent>
								<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
									{title}
								</Typography>
								<Box sx={{ marginTop: 2 }}>
									<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
										{`Processing your withdrawal...`}
									</Typography>
								</Box>
								<Box>
									<CircularProgress color="primary" size={80} thickness={5} />
								</Box>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</>
		);
	}

	return (
		<>
			{balances ? (
				<Grid container spacing={2} sx={{ justifyContent: "center", textAlign: "center" }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<Card sx={{ maxWidth: 500, minWidth: 375 }}>
							<CardContent>
								<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
									{title}
								</Typography>
								<ComboCryptoCoins
									setCryptoCurrency={setCryptoCurrency}
									cryptoCurrency={cryptoCurrency}
									setNetwork={setNetwork}
									token={token}
									setAmount={setAmount}
								/>
								<ComboNetwork setNetwork={setNetwork} network={network} cryptoCurrency={cryptoCurrency} setAddress={setAddress} />
								<InputCryptoAddress setAddress={setAddress} />
								<InputAmountMax
									setAmount={setAmount}
									balance={balance}
									cryptoCurrency={cryptoCurrency}
									network={network}
									currency={currency}
									setCurrency={setCurrency}
									balances={balances}
									setMaxSet={setMaxSet}
								/>
								<Box sx={{ padding: 0, margin: 0 }}>
									<Table sx={{ padding: 0, margin: 0 }}>
										<TableBody>
											<TableRow sx={{ padding: 0, margin: 0 }}>
												<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Balance`}</TableCell>
												<TableCell
													sx={{ textAlign: "right", padding: 0, margin: 0 }}
												>{`${balance} ${cryptoCurrency}`}</TableCell>
											</TableRow>
											<TableRow sx={{ padding: 0, margin: 0 }}>
												<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Exchange Rate`}</TableCell>
												<TableCell sx={{ textAlign: "right", padding: 0, margin: 0 }}>{`$${exchangeRate}`}</TableCell>
											</TableRow>
											<TableRow sx={{ padding: 0, margin: 0 }}>
												<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Balance USD`}</TableCell>
												<TableCell sx={{ textAlign: "right", padding: 0, margin: 0 }}>{`$${parseFloat(
													balance * exchangeRate
												).toFixed(2)}`}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</Box>
								<Grid size={12}>
									<List>
										{network ? (
											<ListItem
												sx={{
													textAlign: "left",
													width: "100%",
													display: "flex",
													paddingLeft: 3,
													paddingRight: 3,
													paddingTop: 0,
													paddingBottom: 0,
													color: "#008000",
													margin: 0,
												}}
											>
												<ListItemIcon sx={{ textAlign: "left", padding: 0, margin: 0, minWidth: 25 }}>
													<Checkbox
														edge="start"
														checked={agreement}
														tabIndex={-1}
														disableRipple
														onChange={changeAgreement}
														sx={{ stroke: "#ffffff", strokeWidth: 1 }}
													/>
												</ListItemIcon>
												<ListItemText
													primary={
														<Typography sx={{ fontSize: "12px", fontWeight: "bold", paddingTop: 2 }}>
															{`Make sure you have selected the right crypto coin and network for your account withdrawal`}
														</Typography>
													}
													sx={{ textAlign: "left", padding: 0, margin: 0, fontSize: "0.7em" }}
												/>
											</ListItem>
										) : null}
										<ListItem sx={{ textAlign: "left", width: "100%", display: "flex", padding: 0 }}>
											<ListItemText
												primary={
													<Typography sx={{ fontSize: "13px", marginTop: 2 }}>
														Please click on SUBMIT to complete your withdrawal.
													</Typography>
												}
												sx={{ textAlign: "center", padding: 0, margin: 0 }}
											/>
										</ListItem>
									</List>
								</Grid>
							</CardContent>
							<CardActions>
								<Box
									sx={{
										alignItems: "center",
										alignContent: "center",
										textAlign: "center",
										width: "100%",
										paddingBottom: 2,
										paddingTop: 1,
									}}
								>
									<Button size="large" sx={styleButton} onClick={nextStep} disabled={disable}>
										SUBMIT
									</Button>
									<Toaster />
								</Box>
							</CardActions>
						</Card>
					</Grid>
				</Grid>
			) : (
				<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
					<Box>
						<CircularProgress color="primary" size={80} thickness={5} />
					</Box>
				</Grid>
			)}
		</>
	);
};

export default SelectCrypto;
